import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteLayout } from "@/components/site/SiteLayout";
import { SERVICES } from "@/data/services";
import { LOCATIONS } from "@/data/areas";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import LocationPage from "@/pages/LocationPage";
import AreasPage from "@/pages/AreasPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import DamagePage from "@/pages/DamagePage";
import ThankYouPage from "@/pages/ThankYouPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminApp from "@/pages/admin/AdminApp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          {SERVICES.map((s) => (
            <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage service={s} />} />
          ))}
          {LOCATIONS.map((l) => (
            <Route key={l.slug} path={`/${l.slug}`} element={<LocationPage location={l} />} />
          ))}
          <Route path="/einsatzgebiet" element={<AreasPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/schaden-melden" element={<DamagePage />} />
          <Route path="/danke" element={<ThankYouPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/galerie" element={<Navigate to="/faq" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
